import * as React from "react";
import { forwardRef } from "react";
const SvgUpcoming = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 4V2H16V4H8V2H6V4H4H3V5V21V22H4H20H21V21V5V4H20H18ZM5 8V6H19V8H5ZM5 10V20H19V10H5Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgUpcoming);
export default ForwardRef;
